import ReactDom from "react-dom";

/**
 * Creates a portal for react elements to be put into
 * Portal is created in the body of the HTML doc
 * @param props passThrough: When passThrough is true, the portal will not be used and all contents will be returned without using the portal
 * @returns
 */
export function Portal(props: {
    passThrough?: boolean;
    children: React.ReactNode;
}) {
    const passthrough =
        props.passThrough === undefined ? false : props.passThrough;
    if (passthrough) {
        return <>{props.children}</>;
    } else {
        return ReactDom.createPortal(props.children, document.body);
    }
}
